module.exports = __webpack_public_path__ + "img/icon_qingpai_des_1.b94d41d2.jpg";